module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('main', [_c('h1', [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('h4', [_vm._v("[" + _vm._s(_vm.card.creator) + "]")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5850d632"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/titlecard.vue
// module id = 279
// module chunks = 1